import { CurrencyPipe } from "@angular/common";
import { Component, inject, input, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { ClaimStatusChartComponent } from "../../charts/claim-status/claim-status-chart.component";
import { CaseStatusWidgetKpi } from "../../models/dashboard-widget-kpi.model";
import { DashboardListNavigationContext } from "../../models/dashboard-list-navigation.model";
import { DashboardNavigationService } from "../../services/dashboard-navigation.service";

@Component({
  selector: "app-dashboard-case-status-widget",
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule,
    CurrencyPipe,
    ClaimStatusChartComponent,
  ],
  templateUrl: "./case-status-widget.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class CaseStatusWidgetComponent {
  private readonly navigationSvc = inject(DashboardNavigationService);

  readonly kpi = input.required<CaseStatusWidgetKpi>();
  readonly listNavigation = input.required<DashboardListNavigationContext>();

  onStatusSelected(statusValue: string): void {
    this.navigationSvc.navigateToCasesList(this.listNavigation(), statusValue);
  }
}
